module.exports = __webpack_public_path__ + "static/media/1-item-c.c07ba179.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/men/1-item-c.jpg
// module id = 496
// module chunks = 33